import { render, staticRenderFns } from "./ImageServerRenderer.vue?vue&type=template&id=12d6df6d&scoped=true"
import script from "./ImageServerRenderer.vue?vue&type=script&lang=js"
export * from "./ImageServerRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6df6d",
  null
  
)

export default component.exports